import styled from "styled-components";

export default styled.div`
&{
  width: 100%;
  height: 100%;
}

.btGenerateContract{
  background-color: ${props => props.theme.colors.complementary};
  color: ${props => props.theme.colors.white};
}

.totalCost{
  font-size: 1.25em;
  font-weight: 500;
}

main{
  display: flex;
  flex-direction:column;
  align-items: flex-start;
  height: auto;
  gap: ${props => props.theme.spacing.spacing_04};
  background-color: transparent;
}

.formInfo{
  p{
    text-transform: capitalize;
    margin: 0px;
  }
  label{
    margin: 0px;
  }

}

.panel{
  padding: ${(props) => props.theme.spacing.spacing_03};
}

.total {
  margin-left: 20px;
}

`